export default "data:image/gif;base64,R0lGODlhHQAPAIAAAP///////yH5BAEHAAEALAAAAAAdAA8AAAIbhI+py+0Po5y02ouz3rz7H4RAGIwiaZYo+hkFADs="